import styled from "styled-components";
import locationIcon from "./icons/location-icon.svg";

const ActivityLocation = styled.h2`
  flex-basis: 50%;
  margin: 0;
  line-height: 1.25;
  height: calc(0.8rem * 1.25);
  color: #484848;
  font-size: 0.8rem;
  font-weight: 400;
  max-height: calc(0.8rem * 1.25);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-image: url(${locationIcon});
  background-origin: content-box;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 0.6rem;
  text-indent: 0.8rem;
`;
export default ActivityLocation;
